import axios from "axios";

const fetchSubscriptions = () =>
  axios.get("neeto_sso/api/v1/server/subscriptions");

const subscriptionsApi = { fetchSubscriptions };

export default subscriptionsApi;
